import React from 'react';
import PropTypes from 'prop-types';
import { redirectToSiteVisitEdit, redirectToVisits } from '../../utils/navigation';
import Button from '../Button/Button';
import { useDialogs, useToasts } from '../../hooks';
import { deleteVisit } from '../../utils/api/visits';
import { handleResponse } from '../../utils/api/errorHandler';

const VisitButtonsFunctionality = ({
  siteId, visitId, organizationId, visitDate, siteName, isManager,
}) => {
  const { openDialog, closeDialog } = useDialogs();
  const { showToast } = useToasts();

  const handleOpenVisitDeleteModal = () => {
    openDialog({
      message: [
        <p className="text-center leading-snug">
          Delete <b>{visitDate}</b> visit for <b>{siteName}</b>?
        </p>,
      ],
      show: true,
      actions: [
        {
          label: 'Cancel',
          variant: 'secondary',
          onClick: closeDialog,
        },
        {
          label: 'Delete visit',
          variant: 'primary',
          dataTestId: 'confirmation-modal-delete-button',
          onClick: () => {
            deleteVisit(organizationId, visitId)
              .then(handleResponse)
              .then(() => {
                closeDialog();
                showToast({ message: `${visitDate} visit for ${siteName} has been deleted`, type: 'success' });
              })
              .then(() => {
                redirectToVisits();
              })
              .catch((error) => {
                closeDialog();
                showToast({ message: error.message, type: 'error' });
              });
          },
        },
      ],
    });
  };
  const pageButtons = [
    ...(isManager ? [{
      label: 'Delete',
      dataTestId: 'delete-visit-button',
      color: 'secondary',
      size: 'md',
      onClick: () => handleOpenVisitDeleteModal(),
    }] : []),
    {
      label: 'Edit',
      color: 'primary',
      size: 'md',
      onClick: () => redirectToSiteVisitEdit(siteId, visitId),
    },
  ];
  return (
    <>
      {pageButtons.map((button) => (
        <Button
          key={button.label}
          label={button.label}
          color={button.color}
          size={button.size}
          onClick={button.onClick}
          dataTestId={button.dataTestId}
        />
      ))}
    </>
  );
};

VisitButtonsFunctionality.propTypes = {
  siteId: PropTypes.number.isRequired,
  visitId: PropTypes.number.isRequired,
  organizationId: PropTypes.number.isRequired,
  visitDate: PropTypes.string.isRequired,
  siteName: PropTypes.string.isRequired,
  isManager: PropTypes.bool.isRequired,
};

export default VisitButtonsFunctionality;
